import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import viVN from 'antd/locale/vi_VN';
import enUS from 'antd/locale/en_US';
import { BrowserRouter } from 'react-router-dom';
import { buildThemeConfig, createI18n, useUiStore } from '@fms/shared';
import { authResources } from '@zero/auth-admin-ui';
import { AppShell } from './App.jsx';
import vi from './i18n/vi.json';
import en from './i18n/en.json';

createI18n({ moduleVi: vi, moduleEn: en, authResources });

function Root() {
  const themeMode = useUiStore((s) => s.themeMode);
  const locale = useUiStore((s) => s.locale);
  return (
    <ConfigProvider
      locale={locale === 'vi' ? viVN : enUS}
      theme={buildThemeConfig(themeMode)}
    >
      <BrowserRouter basename="/fms">
        <AppShell />
      </BrowserRouter>
    </ConfigProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
